<ion-header>
	<app-account-toolbar (back)="goBack()" src="/assets/icons-menu-modal/privacy.svg" title="menu_popover.privacy"></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<!-- Show loading spinner -->
	@if (isLoading) {
	<ion-spinner class="loading-spinner" name="dots"></ion-spinner>
	}

	<!-- Show dynamic content if available -->
	@if (useDynamicContent && legalContent) {
	<div class="legal__content">
		<div [innerHTML]="legalContent"></div>
	</div>
	}

	<!-- Fallback to static content if no dynamic content available -->
</ion-content>
